// extracted by mini-css-extract-plugin
export var button = "Button-module--button--2t432";
export var arrow = "Button-module--arrow--1Zipx";
export var tip = "Button-module--tip--19Af5";
export var line = "Button-module--line--1JdMP";